// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-LoaderSpinner__wrapper","spinner":"c-LoaderSpinner__spinner","spinnerAnimation":"c-LoaderSpinner__spinnerAnimation"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/LoaderSpinner/LoaderSpinner.scss
// module id = 827
// module chunks = 0